/**
 * @generated SignedSource<<11f97c7b94e9a2f09eb6c6abcecb5cb6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest } from 'relay-runtime';
export type agileTutorialOneQuery$variables = {
  limit?: number | null | undefined;
  locale: string;
  urlSlug: string;
};
export type agileTutorialOneQuery$data = {
  readonly tutorialDetailsCollection: {
    readonly items: ReadonlyArray<{
      readonly author: {
        readonly authorPicture: {
          readonly contentType: string | null | undefined;
          readonly description: string | null | undefined;
          readonly fileName: string | null | undefined;
          readonly height: number | null | undefined;
          readonly size: number | null | undefined;
          readonly title: string | null | undefined;
          readonly url: string | null | undefined;
          readonly width: number | null | undefined;
        } | null | undefined;
        readonly jobTitle: string | null | undefined;
        readonly name: string | null | undefined;
        readonly organization: {
          readonly industryCollection: {
            readonly items: ReadonlyArray<{
              readonly name: string | null | undefined;
              readonly shortDescription: string | null | undefined;
            } | null | undefined>;
          } | null | undefined;
          readonly logoCollection: {
            readonly items: ReadonlyArray<{
              readonly contentType: string | null | undefined;
              readonly description: string | null | undefined;
              readonly fileName: string | null | undefined;
              readonly height: number | null | undefined;
              readonly size: number | null | undefined;
              readonly title: string | null | undefined;
              readonly url: string | null | undefined;
              readonly width: number | null | undefined;
            } | null | undefined>;
          } | null | undefined;
          readonly name: string | null | undefined;
          readonly organizationSize: {
            readonly name: string | null | undefined;
            readonly shortDescription: string | null | undefined;
          } | null | undefined;
          readonly region: {
            readonly name: string | null | undefined;
            readonly shortDescription: string | null | undefined;
          } | null | undefined;
          readonly shortDescription: string | null | undefined;
          readonly tagline: string | null | undefined;
        } | null | undefined;
        readonly shortBiography: string | null | undefined;
      } | null | undefined;
      readonly beforeYouBeginCollection: {
        readonly items: ReadonlyArray<{
          readonly audience: {
            readonly json: any;
          } | null | undefined;
          readonly beforeYouBeginTitle: string | null | undefined;
          readonly ctaMicrocopy: {
            readonly ctaButtonText: string | null | undefined;
            readonly ctaMicrocopyTitle: string | null | undefined;
            readonly ctaUrl: string | null | undefined;
          } | null | undefined;
          readonly prerequisite: {
            readonly json: any;
          } | null | undefined;
          readonly relatedAsset: {
            readonly contentType: string | null | undefined;
            readonly description: string | null | undefined;
            readonly fileName: string | null | undefined;
            readonly height: number | null | undefined;
            readonly size: number | null | undefined;
            readonly title: string | null | undefined;
            readonly url: string | null | undefined;
            readonly width: number | null | undefined;
          } | null | undefined;
          readonly relatedQuestions: {
            readonly answer: {
              readonly json: any;
            } | null | undefined;
            readonly answerAsset: {
              readonly contentType: string | null | undefined;
              readonly description: string | null | undefined;
              readonly fileName: string | null | undefined;
              readonly height: number | null | undefined;
              readonly size: number | null | undefined;
              readonly title: string | null | undefined;
              readonly url: string | null | undefined;
              readonly width: number | null | undefined;
            } | null | undefined;
            readonly questionTitle: string | null | undefined;
          } | null | undefined;
          readonly time: string | null | undefined;
        } | null | undefined>;
      } | null | undefined;
      readonly subtitle: string | null | undefined;
      readonly tutorialInstructionsCollection: {
        readonly items: ReadonlyArray<{
          readonly tutorialInstructionStepsCollection: {
            readonly items: ReadonlyArray<{
              readonly tutorialBodyTextContainerCollection: {
                readonly items: ReadonlyArray<{
                  readonly __typename: "AssetComponent";
                  readonly asset: {
                    readonly contentType: string | null | undefined;
                    readonly description: string | null | undefined;
                    readonly fileName: string | null | undefined;
                    readonly height: number | null | undefined;
                    readonly size: number | null | undefined;
                    readonly title: string | null | undefined;
                    readonly url: string | null | undefined;
                    readonly width: number | null | undefined;
                  } | null | undefined;
                  readonly assetRelatedText: {
                    readonly json: any;
                  } | null | undefined;
                  readonly caption: string | null | undefined;
                } | {
                  readonly __typename: "CallOutComponent";
                  readonly callOutText: {
                    readonly json: any;
                  } | null | undefined;
                  readonly icon: {
                    readonly contentType: string | null | undefined;
                    readonly description: string | null | undefined;
                    readonly fileName: string | null | undefined;
                    readonly height: number | null | undefined;
                    readonly size: number | null | undefined;
                    readonly title: string | null | undefined;
                    readonly url: string | null | undefined;
                    readonly width: number | null | undefined;
                  } | null | undefined;
                  readonly title: string | null | undefined;
                } | {
                  readonly __typename: "CallToAction";
                  readonly asset: {
                    readonly contentType: string | null | undefined;
                    readonly description: string | null | undefined;
                    readonly fileName: string | null | undefined;
                    readonly height: number | null | undefined;
                    readonly size: number | null | undefined;
                    readonly title: string | null | undefined;
                    readonly url: string | null | undefined;
                    readonly width: number | null | undefined;
                  } | null | undefined;
                  readonly ctaText: string | null | undefined;
                  readonly dataBlueprintModule: string | null | undefined;
                  readonly productCollection: {
                    readonly items: ReadonlyArray<{
                      readonly productNameReference: {
                        readonly productName: string | null | undefined;
                      } | null | undefined;
                    } | null | undefined>;
                  } | null | undefined;
                  readonly title: string | null | undefined;
                  readonly url: string | null | undefined;
                  readonly valueProposition: string | null | undefined;
                } | {
                  readonly __typename: "ProTipComponent";
                  readonly name: string | null | undefined;
                  readonly proTipText: string | null | undefined;
                } | {
                  readonly __typename: "QuestionComponent";
                  readonly answer: {
                    readonly json: any;
                  } | null | undefined;
                  readonly questionTitle: string | null | undefined;
                } | {
                  readonly __typename: "TextComponent";
                  readonly name: string | null | undefined;
                  readonly text: {
                    readonly json: any;
                  } | null | undefined;
                } | {
                  readonly __typename: "TwitterComponent";
                  readonly tweetText: string | null | undefined;
                  readonly twitterComponentName: string | null | undefined;
                  readonly twitterUrl: string | null | undefined;
                } | {
                  // This will never be '%other', but we need some
                  // value in case none of the concrete values match.
                  readonly __typename: "%other";
                } | null | undefined>;
              } | null | undefined;
              readonly tutorialUseStepTitle: string | null | undefined;
            } | null | undefined>;
          } | null | undefined;
          readonly tutorialInstructionsTitle: string | null | undefined;
        } | null | undefined>;
      } | null | undefined;
      readonly tutorialIntroductionCollection: {
        readonly items: ReadonlyArray<{
          readonly embedLink: string | null | undefined;
          readonly tutorialIntroductionAsset: {
            readonly contentType: string | null | undefined;
            readonly description: string | null | undefined;
            readonly fileName: string | null | undefined;
            readonly height: number | null | undefined;
            readonly size: number | null | undefined;
            readonly title: string | null | undefined;
            readonly url: string | null | undefined;
            readonly width: number | null | undefined;
          } | null | undefined;
          readonly tutorialIntroductionDetails: {
            readonly json: any;
          } | null | undefined;
          readonly tutorialIntroductionName: string | null | undefined;
        } | null | undefined>;
      } | null | undefined;
      readonly tutorialRef: {
        readonly description: string | null | undefined;
        readonly title: string | null | undefined;
        readonly tutorialBanner: {
          readonly contentType: string | null | undefined;
          readonly description: string | null | undefined;
          readonly fileName: string | null | undefined;
          readonly height: number | null | undefined;
          readonly size: number | null | undefined;
          readonly title: string | null | undefined;
          readonly url: string | null | undefined;
          readonly width: number | null | undefined;
        } | null | undefined;
        readonly tutorialName: string | null | undefined;
        readonly urlSlug: string | null | undefined;
      } | null | undefined;
      readonly tutorialSummary: {
        readonly json: any;
      } | null | undefined;
    } | null | undefined>;
  } | null | undefined;
};
export type agileTutorialOneQuery = {
  response: agileTutorialOneQuery$data;
  variables: agileTutorialOneQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": 1,
  "kind": "LocalArgument",
  "name": "limit"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "locale"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "urlSlug"
},
v3 = [
  {
    "kind": "Variable",
    "name": "limit",
    "variableName": "limit"
  },
  {
    "kind": "Variable",
    "name": "locale",
    "variableName": "locale"
  },
  {
    "fields": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "urlSlug",
            "variableName": "urlSlug"
          }
        ],
        "kind": "ObjectValue",
        "name": "tutorialRef"
      }
    ],
    "kind": "ObjectValue",
    "name": "where"
  }
],
v4 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "title",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "description",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "url",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "width",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "height",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "size",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "fileName",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "contentType",
    "storageKey": null
  }
],
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "Tutorial",
  "kind": "LinkedField",
  "name": "tutorialRef",
  "plural": false,
  "selections": [
    {
      "alias": "title",
      "args": null,
      "kind": "ScalarField",
      "name": "tutorialTitle",
      "storageKey": null
    },
    {
      "alias": "tutorialName",
      "args": null,
      "kind": "ScalarField",
      "name": "tutorialNameExternal",
      "storageKey": null
    },
    {
      "alias": "description",
      "args": null,
      "kind": "ScalarField",
      "name": "tutorialDescription",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "urlSlug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Asset",
      "kind": "LinkedField",
      "name": "tutorialBanner",
      "plural": false,
      "selections": (v4/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v6 = {
  "alias": "subtitle",
  "args": null,
  "kind": "ScalarField",
  "name": "tutorialSubtitle",
  "storageKey": null
},
v7 = [
  {
    "kind": "Literal",
    "name": "limit",
    "value": 1
  }
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shortDescription",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "Author",
  "kind": "LinkedField",
  "name": "author",
  "plural": false,
  "selections": [
    {
      "alias": "name",
      "args": null,
      "kind": "ScalarField",
      "name": "authorNameExternal",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "jobTitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Asset",
      "kind": "LinkedField",
      "name": "authorPicture",
      "plural": false,
      "selections": (v4/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "shortBiography",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CompanyNameInternal",
      "kind": "LinkedField",
      "name": "organization",
      "plural": false,
      "selections": [
        {
          "alias": "name",
          "args": null,
          "kind": "ScalarField",
          "name": "organizationNameExternal",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "tagline",
          "storageKey": null
        },
        {
          "alias": null,
          "args": (v7/*: any*/),
          "concreteType": "AssetCollection",
          "kind": "LinkedField",
          "name": "logoCollection",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Asset",
              "kind": "LinkedField",
              "name": "items",
              "plural": true,
              "selections": (v4/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": "logoCollection(limit:1)"
        },
        (v8/*: any*/),
        {
          "alias": null,
          "args": (v7/*: any*/),
          "concreteType": "CompanyNameInternalIndustryCollection",
          "kind": "LinkedField",
          "name": "industryCollection",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "TaxonomyIndustry",
              "kind": "LinkedField",
              "name": "items",
              "plural": true,
              "selections": [
                {
                  "alias": "name",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "industryNameExternal",
                  "storageKey": null
                },
                (v8/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": "industryCollection(limit:1)"
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "TaxonomyCompanySize",
          "kind": "LinkedField",
          "name": "organizationSize",
          "plural": false,
          "selections": [
            {
              "alias": "name",
              "args": null,
              "kind": "ScalarField",
              "name": "companySizeTitleExternal",
              "storageKey": null
            },
            (v8/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "TaxonomyRegion",
          "kind": "LinkedField",
          "name": "region",
          "plural": false,
          "selections": [
            {
              "alias": "name",
              "args": null,
              "kind": "ScalarField",
              "name": "regionNameExternal",
              "storageKey": null
            },
            (v8/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v10 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "json",
    "storageKey": null
  }
],
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "TutorialDetailsTutorialSummary",
  "kind": "LinkedField",
  "name": "tutorialSummary",
  "plural": false,
  "selections": (v10/*: any*/),
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": (v7/*: any*/),
  "concreteType": "TutorialDetailsTutorialIntroductionCollection",
  "kind": "LinkedField",
  "name": "tutorialIntroductionCollection",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TutorialIntroduction",
      "kind": "LinkedField",
      "name": "items",
      "plural": true,
      "selections": [
        {
          "alias": "tutorialIntroductionName",
          "args": null,
          "kind": "ScalarField",
          "name": "tutorialIntroductionTitleExternal",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "TutorialIntroductionTutorialIntroductionDetails",
          "kind": "LinkedField",
          "name": "tutorialIntroductionDetails",
          "plural": false,
          "selections": (v10/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Asset",
          "kind": "LinkedField",
          "name": "tutorialIntroductionAsset",
          "plural": false,
          "selections": (v4/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "embedLink",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "tutorialIntroductionCollection(limit:1)"
},
v13 = {
  "alias": "questionTitle",
  "args": null,
  "kind": "ScalarField",
  "name": "questionTitleExternal",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "QuestionComponentAnswer",
  "kind": "LinkedField",
  "name": "answer",
  "plural": false,
  "selections": (v10/*: any*/),
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": (v7/*: any*/),
  "concreteType": "TutorialDetailsBeforeYouBeginCollection",
  "kind": "LinkedField",
  "name": "beforeYouBeginCollection",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "BeforeYouBeginComponent",
      "kind": "LinkedField",
      "name": "items",
      "plural": true,
      "selections": [
        {
          "alias": "beforeYouBeginTitle",
          "args": null,
          "kind": "ScalarField",
          "name": "beforeYouBeginTitleExternal",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "time",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "BeforeYouBeginComponentAudience",
          "kind": "LinkedField",
          "name": "audience",
          "plural": false,
          "selections": (v10/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "BeforeYouBeginComponentPrerequisite",
          "kind": "LinkedField",
          "name": "prerequisite",
          "plural": false,
          "selections": (v10/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "CallToActionMicrocopy",
          "kind": "LinkedField",
          "name": "ctaMicrocopy",
          "plural": false,
          "selections": [
            {
              "alias": "ctaMicrocopyTitle",
              "args": null,
              "kind": "ScalarField",
              "name": "ctaMicrocopyTitleExternal",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "ctaButtonText",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "ctaUrl",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Asset",
          "kind": "LinkedField",
          "name": "relatedAsset",
          "plural": false,
          "selections": (v4/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "QuestionComponent",
          "kind": "LinkedField",
          "name": "relatedQuestions",
          "plural": false,
          "selections": [
            (v13/*: any*/),
            (v14/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Asset",
              "kind": "LinkedField",
              "name": "answerAsset",
              "plural": false,
              "selections": (v4/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "beforeYouBeginCollection(limit:1)"
},
v16 = {
  "alias": "tutorialInstructionsTitle",
  "args": null,
  "kind": "ScalarField",
  "name": "tutorialInstructionsTitleExternal",
  "storageKey": null
},
v17 = {
  "alias": "tutorialUseStepTitle",
  "args": null,
  "kind": "ScalarField",
  "name": "tutorialUseStepTitleExternal",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v19 = {
  "alias": "caption",
  "args": null,
  "kind": "ScalarField",
  "name": "assetCaption",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "AssetComponentAssetRelatedText",
  "kind": "LinkedField",
  "name": "assetRelatedText",
  "plural": false,
  "selections": (v10/*: any*/),
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "concreteType": "Asset",
  "kind": "LinkedField",
  "name": "asset",
  "plural": false,
  "selections": (v4/*: any*/),
  "storageKey": null
},
v22 = {
  "alias": "name",
  "args": null,
  "kind": "ScalarField",
  "name": "proTipNameExternal",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "proTipText",
  "storageKey": null
},
v24 = {
  "alias": "name",
  "args": null,
  "kind": "ScalarField",
  "name": "textComponentNameExternal",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "concreteType": "TextComponentText",
  "kind": "LinkedField",
  "name": "text",
  "plural": false,
  "selections": (v10/*: any*/),
  "storageKey": null
},
v26 = {
  "alias": "twitterComponentName",
  "args": null,
  "kind": "ScalarField",
  "name": "twitterComponentExternalName",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tweetText",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "twitterUrl",
  "storageKey": null
},
v29 = {
  "alias": "title",
  "args": null,
  "kind": "ScalarField",
  "name": "ctaTitleExternal",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "valueProposition",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ctaText",
  "storageKey": null
},
v32 = {
  "alias": "url",
  "args": null,
  "kind": "ScalarField",
  "name": "ctaUrl",
  "storageKey": null
},
v33 = {
  "alias": "asset",
  "args": null,
  "concreteType": "Asset",
  "kind": "LinkedField",
  "name": "ctaAsset",
  "plural": false,
  "selections": (v4/*: any*/),
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": (v7/*: any*/),
  "concreteType": "CallToActionProductCollection",
  "kind": "LinkedField",
  "name": "productCollection",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductListing",
      "kind": "LinkedField",
      "name": "items",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProductName",
          "kind": "LinkedField",
          "name": "productNameReference",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "productName",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "productCollection(limit:1)"
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dataBlueprintModule",
  "storageKey": null
},
v36 = {
  "alias": "title",
  "args": null,
  "kind": "ScalarField",
  "name": "callOutComponentTitleExternal",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "concreteType": "CallOutComponentCallOutText",
  "kind": "LinkedField",
  "name": "callOutText",
  "plural": false,
  "selections": (v10/*: any*/),
  "storageKey": null
},
v38 = {
  "alias": "icon",
  "args": null,
  "concreteType": "Asset",
  "kind": "LinkedField",
  "name": "callOutComponentIcon",
  "plural": false,
  "selections": (v4/*: any*/),
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "agileTutorialOneQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "TutorialDetailsCollection",
        "kind": "LinkedField",
        "name": "tutorialDetailsCollection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TutorialDetails",
            "kind": "LinkedField",
            "name": "items",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              (v9/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v15/*: any*/),
              {
                "alias": null,
                "args": (v7/*: any*/),
                "concreteType": "TutorialDetailsTutorialInstructionsCollection",
                "kind": "LinkedField",
                "name": "tutorialInstructionsCollection",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TutorialInstructionsWrapper",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": true,
                    "selections": [
                      (v16/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TutorialInstructionsWrapperTutorialInstructionStepsCollection",
                        "kind": "LinkedField",
                        "name": "tutorialInstructionStepsCollection",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TutorialUseStep",
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": true,
                            "selections": [
                              (v17/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TutorialUseStepTutorialBodyTextContainerCollection",
                                "kind": "LinkedField",
                                "name": "tutorialBodyTextContainerCollection",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "items",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v18/*: any*/),
                                          (v19/*: any*/),
                                          (v20/*: any*/),
                                          (v21/*: any*/)
                                        ],
                                        "type": "AssetComponent",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v18/*: any*/),
                                          (v22/*: any*/),
                                          (v23/*: any*/)
                                        ],
                                        "type": "ProTipComponent",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v18/*: any*/),
                                          (v24/*: any*/),
                                          (v25/*: any*/)
                                        ],
                                        "type": "TextComponent",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v18/*: any*/),
                                          (v26/*: any*/),
                                          (v27/*: any*/),
                                          (v28/*: any*/)
                                        ],
                                        "type": "TwitterComponent",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v18/*: any*/),
                                          (v29/*: any*/),
                                          (v30/*: any*/),
                                          (v31/*: any*/),
                                          (v32/*: any*/),
                                          (v33/*: any*/),
                                          (v34/*: any*/),
                                          (v35/*: any*/)
                                        ],
                                        "type": "CallToAction",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v18/*: any*/),
                                          (v13/*: any*/),
                                          (v14/*: any*/)
                                        ],
                                        "type": "QuestionComponent",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v18/*: any*/),
                                          (v36/*: any*/),
                                          (v37/*: any*/),
                                          (v38/*: any*/)
                                        ],
                                        "type": "CallOutComponent",
                                        "abstractKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "tutorialInstructionsCollection(limit:1)"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "agileTutorialOneQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "TutorialDetailsCollection",
        "kind": "LinkedField",
        "name": "tutorialDetailsCollection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TutorialDetails",
            "kind": "LinkedField",
            "name": "items",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              (v9/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v15/*: any*/),
              {
                "alias": null,
                "args": (v7/*: any*/),
                "concreteType": "TutorialDetailsTutorialInstructionsCollection",
                "kind": "LinkedField",
                "name": "tutorialInstructionsCollection",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TutorialInstructionsWrapper",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": true,
                    "selections": [
                      (v16/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TutorialInstructionsWrapperTutorialInstructionStepsCollection",
                        "kind": "LinkedField",
                        "name": "tutorialInstructionStepsCollection",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TutorialUseStep",
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": true,
                            "selections": [
                              (v17/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TutorialUseStepTutorialBodyTextContainerCollection",
                                "kind": "LinkedField",
                                "name": "tutorialBodyTextContainerCollection",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "items",
                                    "plural": true,
                                    "selections": [
                                      (v18/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v19/*: any*/),
                                          (v20/*: any*/),
                                          (v21/*: any*/)
                                        ],
                                        "type": "AssetComponent",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v22/*: any*/),
                                          (v23/*: any*/)
                                        ],
                                        "type": "ProTipComponent",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v24/*: any*/),
                                          (v25/*: any*/)
                                        ],
                                        "type": "TextComponent",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v26/*: any*/),
                                          (v27/*: any*/),
                                          (v28/*: any*/)
                                        ],
                                        "type": "TwitterComponent",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v29/*: any*/),
                                          (v30/*: any*/),
                                          (v31/*: any*/),
                                          (v32/*: any*/),
                                          (v33/*: any*/),
                                          (v34/*: any*/),
                                          (v35/*: any*/)
                                        ],
                                        "type": "CallToAction",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v13/*: any*/),
                                          (v14/*: any*/)
                                        ],
                                        "type": "QuestionComponent",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v36/*: any*/),
                                          (v37/*: any*/),
                                          (v38/*: any*/)
                                        ],
                                        "type": "CallOutComponent",
                                        "abstractKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "tutorialInstructionsCollection(limit:1)"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2c6dff0fdf5783b534e72b98e9edf8f6",
    "id": null,
    "metadata": {},
    "name": "agileTutorialOneQuery",
    "operationKind": "query",
    "text": "query agileTutorialOneQuery(\n  $limit: Int = 1\n  $urlSlug: String!\n  $locale: String!\n) {\n  tutorialDetailsCollection(limit: $limit, where: {tutorialRef: {urlSlug: $urlSlug}}, locale: $locale) {\n    items {\n      tutorialRef {\n        title: tutorialTitle\n        tutorialName: tutorialNameExternal\n        description: tutorialDescription\n        urlSlug\n        tutorialBanner {\n          title\n          description\n          url\n          width\n          height\n          size\n          fileName\n          contentType\n        }\n      }\n      subtitle: tutorialSubtitle\n      author {\n        name: authorNameExternal\n        jobTitle\n        authorPicture {\n          title\n          description\n          url\n          width\n          height\n          size\n          fileName\n          contentType\n        }\n        shortBiography\n        organization {\n          name: organizationNameExternal\n          tagline\n          logoCollection(limit: 1) {\n            items {\n              title\n              description\n              url\n              width\n              height\n              size\n              fileName\n              contentType\n            }\n          }\n          shortDescription\n          industryCollection(limit: 1) {\n            items {\n              name: industryNameExternal\n              shortDescription\n            }\n          }\n          organizationSize {\n            name: companySizeTitleExternal\n            shortDescription\n          }\n          region {\n            name: regionNameExternal\n            shortDescription\n          }\n        }\n      }\n      tutorialSummary {\n        json\n      }\n      tutorialIntroductionCollection(limit: 1) {\n        items {\n          tutorialIntroductionName: tutorialIntroductionTitleExternal\n          tutorialIntroductionDetails {\n            json\n          }\n          tutorialIntroductionAsset {\n            title\n            description\n            url\n            width\n            height\n            size\n            fileName\n            contentType\n          }\n          embedLink\n        }\n      }\n      beforeYouBeginCollection(limit: 1) {\n        items {\n          beforeYouBeginTitle: beforeYouBeginTitleExternal\n          time\n          audience {\n            json\n          }\n          prerequisite {\n            json\n          }\n          ctaMicrocopy {\n            ctaMicrocopyTitle: ctaMicrocopyTitleExternal\n            ctaButtonText\n            ctaUrl\n          }\n          relatedAsset {\n            title\n            description\n            url\n            width\n            height\n            size\n            fileName\n            contentType\n          }\n          relatedQuestions {\n            questionTitle: questionTitleExternal\n            answer {\n              json\n            }\n            answerAsset {\n              title\n              description\n              url\n              width\n              height\n              size\n              fileName\n              contentType\n            }\n          }\n        }\n      }\n      tutorialInstructionsCollection(limit: 1) {\n        items {\n          tutorialInstructionsTitle: tutorialInstructionsTitleExternal\n          tutorialInstructionStepsCollection {\n            items {\n              tutorialUseStepTitle: tutorialUseStepTitleExternal\n              tutorialBodyTextContainerCollection {\n                items {\n                  __typename\n                  ... on AssetComponent {\n                    __typename\n                    caption: assetCaption\n                    assetRelatedText {\n                      json\n                    }\n                    asset {\n                      title\n                      description\n                      url\n                      width\n                      height\n                      size\n                      fileName\n                      contentType\n                    }\n                  }\n                  ... on ProTipComponent {\n                    __typename\n                    name: proTipNameExternal\n                    proTipText\n                  }\n                  ... on TextComponent {\n                    __typename\n                    name: textComponentNameExternal\n                    text {\n                      json\n                    }\n                  }\n                  ... on TwitterComponent {\n                    __typename\n                    twitterComponentName: twitterComponentExternalName\n                    tweetText\n                    twitterUrl\n                  }\n                  ... on CallToAction {\n                    __typename\n                    title: ctaTitleExternal\n                    valueProposition\n                    ctaText\n                    url: ctaUrl\n                    asset: ctaAsset {\n                      title\n                      description\n                      url\n                      width\n                      height\n                      size\n                      fileName\n                      contentType\n                    }\n                    productCollection(limit: 1) {\n                      items {\n                        productNameReference {\n                          productName\n                        }\n                      }\n                    }\n                    dataBlueprintModule\n                  }\n                  ... on QuestionComponent {\n                    __typename\n                    questionTitle: questionTitleExternal\n                    answer {\n                      json\n                    }\n                  }\n                  ... on CallOutComponent {\n                    __typename\n                    title: callOutComponentTitleExternal\n                    callOutText {\n                      json\n                    }\n                    icon: callOutComponentIcon {\n                      title\n                      description\n                      url\n                      width\n                      height\n                      size\n                      fileName\n                      contentType\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "44dad19b23fbe9522dd494a241a0271a";

export default node;
